import React from 'react';

function DeActive() {
  return <div>DeActive</div>;
}

export default DeActive;
